export const toArray = nodeList => [].slice.call(nodeList);

export default toArray;
